module.exports = __webpack_public_path__ + "cement/img/GzH.9555590d.jpg";